<template>
<div>
    <el-container>
        
        <el-header>
            <el-row type="flex" justify="end">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="1">首页</el-menu-item>
                <el-menu-item index="2">个人中心</el-menu-item>
                <el-menu-item index="3">关于我们</el-menu-item>
                <el-menu-item index="4" disabled="true">
                    <el-input
                        placeholder="请输入内容"
                        prefix-icon="el-icon-search"
                        v-model="input2">
                    </el-input></el-menu-item>
                <el-menu-item index="5" disabled="true">
                                                <div class="block"><el-avatar :size="50" :src="circleUrl"></el-avatar></div>
</el-menu-item>

            </el-menu>
        </el-row>
            
        </el-header>

        <!-- <el-main>Main</el-main> -->
    </el-container>
</div>
</template>

<script>
export default {
    name:'AuthorCenter',
    data() {
      return {
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        activeIndex: '1',
        activeIndex2: '1'
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/AuthorCenter.vue